import { useTranslation } from "react-i18next";
import {
  MonthOverviewActionContainer,
  MonthOverviewButtonsContainer,
  SalaryPageContainer,
} from "./salary.styled";
import { useState } from "react";
import { Color } from "config/colors";
import { ButtonStyled } from "components/buttons/buttons.styled";
import { EditWorkingHoursModal } from "./editWorkingHoursModal.component";
import { SalaryList } from "./salaryList.component";
import { WorkerDropdown } from "./workerDropDown.component";
import { CompanyWorker } from "model/Company";

export const MonthOverview = () => {
  const { t } = useTranslation();
  const [editWorkingHours, setEditWorkingHours] = useState(false);
  const [selectedWorker, setSelectedWorker] = useState<CompanyWorker>();

  return (
    <SalaryPageContainer>
      <MonthOverviewActionContainer>
        <WorkerDropdown
          selectedWorker={selectedWorker}
          setSelectedWorker={setSelectedWorker}
          onlyActiveWorkers={false}
        />
        <MonthOverviewButtonsContainer>
          <ButtonStyled
            onClick={() => setEditWorkingHours(true)}
            backgroundColor={Color.ModernGreen}
            style={{ marginRight: 10, height: "40px" }}
            lessPadding
          >
            {t("Salary.EditMonthHours")}
          </ButtonStyled>
        </MonthOverviewButtonsContainer>
      </MonthOverviewActionContainer>
      {editWorkingHours && (
        <EditWorkingHoursModal
          setEditWorkingHours={setEditWorkingHours}
          editWorkingHours={editWorkingHours}
        />
      )}
      <SalaryList selectedWorker={selectedWorker?.id} />
    </SalaryPageContainer>
  );
};
